import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NamedLocationFieldsFragment = { __typename?: 'NamedLocation', latitude: number, longitude: number, canonicalName: string, code: string, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }>, ancestors: Array<{ __typename?: 'NamedLocationAncestor', canonicalName: string, code: string, latitude: number, longitude: number, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }> }> };

export type Gen2LocationFieldsFragment = { __typename?: 'Location', latitude: number, longitude: number, precisionKm: number, country: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string }, admin1?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin2?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin3?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin4?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin5?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin6?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, postalCode?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null, preciseLocation?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null };

export type ValidateLocationDataQueryVariables = Types.Exact<{
  location: Types.LocationDataInput;
  language: Types.Scalars['LanguageCode']['input'];
}>;


export type ValidateLocationDataQuery = { __typename?: 'Query', validateLocationData?: { __typename?: 'ValidateLocationResult', formattedName: string, location: { __typename?: 'NamedLocation', latitude: number, longitude: number, canonicalName: string, code: string, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }>, ancestors: Array<{ __typename?: 'NamedLocationAncestor', canonicalName: string, code: string, latitude: number, longitude: number, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }> }> }, gen2Location: { __typename?: 'Location', latitude: number, longitude: number, precisionKm: number, country: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string }, admin1?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin2?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin3?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin4?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin5?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin6?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, postalCode?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null, preciseLocation?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null } } | null };

export type ValidateStringLocationQueryVariables = Types.Exact<{
  location: Types.Scalars['String']['input'];
  country: Types.Scalars['CountryCode']['input'];
  language: Types.Scalars['LanguageCode']['input'];
  preciseLocation: Types.Scalars['Boolean']['input'];
}>;


export type ValidateStringLocationQuery = { __typename?: 'Query', locationInputComponentStringPrefill?: { __typename?: 'ValidateLocationResult', formattedName: string, location: { __typename?: 'NamedLocation', latitude: number, longitude: number, canonicalName: string, code: string, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }>, ancestors: Array<{ __typename?: 'NamedLocationAncestor', canonicalName: string, code: string, latitude: number, longitude: number, locationPrecisionKilometers: number, locationType: Types.LocationType, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }> }> }, gen2Location: { __typename?: 'Location', latitude: number, longitude: number, precisionKm: number, country: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string }, admin1?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin2?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin3?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin4?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin5?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin6?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, postalCode?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null, preciseLocation?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null } } | null };

export const NamedLocationFieldsFragmentDoc = gql`
    fragment NamedLocationFields on NamedLocation {
  latitude
  longitude
  aliases {
    alias
    languageCode
  }
  ancestors {
    aliases {
      alias
      languageCode
    }
    canonicalName
    code
    latitude
    longitude
    locationPrecisionKilometers
    locationType
  }
  canonicalName
  code
  locationPrecisionKilometers
  locationType
}
    `;
export const Gen2LocationFieldsFragmentDoc = gql`
    fragment Gen2LocationFields on Location {
  country {
    id
    name
    code
  }
  admin1 {
    id
    name
    code
  }
  admin2 {
    id
    name
    code
  }
  admin3 {
    id
    name
    code
  }
  admin4 {
    id
    name
    code
  }
  admin5 {
    id
    name
    code
  }
  admin6 {
    id
    name
    code
  }
  postalCode {
    id
    name
  }
  preciseLocation {
    id
    name
  }
  latitude
  longitude
  precisionKm
}
    `;
export const ValidateLocationDataDocument = gql`
    query ValidateLocationData($location: LocationDataInput!, $language: LanguageCode!) {
  validateLocationData(input: {location: $location, language: $language}) {
    location {
      ...NamedLocationFields
    }
    formattedName
    gen2Location {
      ...Gen2LocationFields
    }
  }
}
    ${NamedLocationFieldsFragmentDoc}
${Gen2LocationFieldsFragmentDoc}`;

/**
 * __useValidateLocationDataQuery__
 *
 * To run a query within a React component, call `useValidateLocationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLocationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLocationDataQuery({
 *   variables: {
 *      location: // value for 'location'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useValidateLocationDataQuery(baseOptions: Apollo.QueryHookOptions<ValidateLocationDataQuery, ValidateLocationDataQueryVariables> & ({ variables: ValidateLocationDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>(ValidateLocationDataDocument, options);
      }
export function useValidateLocationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>(ValidateLocationDataDocument, options);
        }
export function useValidateLocationDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>(ValidateLocationDataDocument, options);
        }
export type ValidateLocationDataQueryHookResult = ReturnType<typeof useValidateLocationDataQuery>;
export type ValidateLocationDataLazyQueryHookResult = ReturnType<typeof useValidateLocationDataLazyQuery>;
export type ValidateLocationDataSuspenseQueryHookResult = ReturnType<typeof useValidateLocationDataSuspenseQuery>;
export type ValidateLocationDataQueryResult = Apollo.QueryResult<ValidateLocationDataQuery, ValidateLocationDataQueryVariables>;
export const ValidateStringLocationDocument = gql`
    query ValidateStringLocation($location: String!, $country: CountryCode!, $language: LanguageCode!, $preciseLocation: Boolean!) {
  locationInputComponentStringPrefill(
    input: {location: $location, country: $country, language: $language, preciseLocation: $preciseLocation}
  ) {
    location {
      ...NamedLocationFields
    }
    formattedName
    gen2Location {
      ...Gen2LocationFields
    }
  }
}
    ${NamedLocationFieldsFragmentDoc}
${Gen2LocationFieldsFragmentDoc}`;

/**
 * __useValidateStringLocationQuery__
 *
 * To run a query within a React component, call `useValidateStringLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateStringLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateStringLocationQuery({
 *   variables: {
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      preciseLocation: // value for 'preciseLocation'
 *   },
 * });
 */
export function useValidateStringLocationQuery(baseOptions: Apollo.QueryHookOptions<ValidateStringLocationQuery, ValidateStringLocationQueryVariables> & ({ variables: ValidateStringLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>(ValidateStringLocationDocument, options);
      }
export function useValidateStringLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>(ValidateStringLocationDocument, options);
        }
export function useValidateStringLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>(ValidateStringLocationDocument, options);
        }
export type ValidateStringLocationQueryHookResult = ReturnType<typeof useValidateStringLocationQuery>;
export type ValidateStringLocationLazyQueryHookResult = ReturnType<typeof useValidateStringLocationLazyQuery>;
export type ValidateStringLocationSuspenseQueryHookResult = ReturnType<typeof useValidateStringLocationSuspenseQuery>;
export type ValidateStringLocationQueryResult = Apollo.QueryResult<ValidateStringLocationQuery, ValidateStringLocationQueryVariables>;